import {z} from 'src/lib'
import {
  schemaFormOperacionControlOperativo,
  schemaFormOperacionControlOperativoDetalle,
  schemaOperacionControlOperativo, schemaOperacionControlOperativoDetalle
} from "./types";
import {OperacionControlOperativoFields} from "./fields";

export type OperacionControlOperativoDetalleInsertDTO = z.infer<typeof schemaFormOperacionControlOperativoDetalle>;

export const schemaOperacionControlOperativoInsert = schemaFormOperacionControlOperativo.extend({
  [OperacionControlOperativoFields.Detalle]: schemaFormOperacionControlOperativoDetalle,
  [OperacionControlOperativoFields.Envio]: z.boolean(),
});
export type OperacionControlOperativoInsertDTO = z.infer<typeof schemaOperacionControlOperativoInsert>;


export const schemaOperacionControlOperativoView = schemaOperacionControlOperativo.omit({[OperacionControlOperativoFields.Envio]: true})
export type OperacionControlOperativoViewDTO = z.infer<typeof schemaOperacionControlOperativoView>

